var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"), url(" + escape(require("./Roboto.ttf")) + ") format(\"truetype\");\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/components/core/public/fonts.css
// module id = 172
// module chunks = 0